import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

type UseTemplatePDFParams = {
    templateId: number;
    reactQueryOptions?: UseQueryOptions<Blob, Error>;
};

const useTemplatePDF = ({ templateId, reactQueryOptions }: UseTemplatePDFParams) =>
    useQuery<Blob>(
        QueryKeys.TEMPLATE_PDF(templateId),
        `${CuredApiPaths.TEMPLATES}/${templateId}/pdf`,
        reactQueryOptions,
        { responseType: 'blob' }
    );

export default useTemplatePDF;
